import React from 'react';
import { Form, NestedField } from 'react-form';
import PropTypes from 'prop-types';

import links from '../../../../config/links';
import Popup from '../../../components/Popup';
import {
    ToggleSwitch,
} from '../../../components/Form';

import styles from './publishedPopup.scss';

const PublishedPopup = (props) => {
    const { firstName, clubName, eventName, eventDescription, eventStartMonth, eventStartDate, verifiedEvent, isGroupPlayEvent, usapVerificationTypeId, isRecurringEvent } = props;
    return (
        <Popup
            className={`popup-sm ${styles.publishedPopup}`}
            onCloseClick={props.onCloseClick}
            data-testid="event-published-popup"
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: true,
                style: {
                    height: usapVerificationTypeId ? 650 : 620,
                    width: usapVerificationTypeId ? 450 : 400,
                    maxHeight: '100%',
                },
            }}
        >
            <div className={`popup-section p24 pt0 lh40 pb0`}>
                {isRecurringEvent ? (
                    <div>
                        <div className={styles.recurringTitle}>
                            Your Recurring Events are Being Created
                        </div>
                        <div className={styles.recurringBody}>
                            We’re building your events. You can continue working; your events will automatically appear in your Digital Club at the selected publish state once processing is finished.
                        </div>
                    </div>
                ) : (
                    <h5>
                        Well {isGroupPlayEvent ? 'player' : 'played'}, {firstName}.<br />
                        <span className="text-gray">Congrats on creating your event!</span>
                    </h5>
                )}
            </div>
            {!usapVerificationTypeId && (
                <div className="popup-section popup-section-gradient p24">
                    <div className="event-preview-card">
                        <div className="row">
                            <div className="col-9">
                                <div className="left-wrapper">
                                    <div className="club text-hightlight1 mb24 ellipsis">{clubName}</div>
                                    <h5 className="event-name ellipsis">{eventName} {verifiedEvent && <i className="utr utr-sanctioned" />}</h5>
                                    <div className="text-small text-gray">{eventDescription}</div>
                                </div>
                            </div>
                            <div className="col-3 bl d-flex">
                                <div className="right-wrapper">
                                    <div className="month text-small text-uppercase">{eventStartMonth}</div>
                                    <h5 className="day">{eventStartDate}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="popup-section p24">
                {usapVerificationTypeId && (
                    <>
                        <p className="text-danger text-medium text-uppercase">Important Information</p>
                        <p className="text-dark text-bold">USAP Event Sanctioning</p>
                        <ul>
                            <li>Please <a href={links.usapApplication} target="_blank" rel="noopener noreferrer">click here</a> to complete the USAP Sanctioning Application.</li>
                            <li>Until approved, your event will show a &lsquo;USAP Sanctioning Pending&rsquo; logo.</li>
                            <li>Players need an active USAP Membership ID to register and will be prompted for it during registration.</li>
                        </ul>
                    </>
                )}
                <p className={`text-dark text-bold`}>What’s next?</p>
                { isGroupPlayEvent
                    ? (
                        <ul>
                            <li>Invite group members</li>
                            <li>Coordinate play with attendees</li>
                            <li>Self-post scores from match play</li>
                        </ul>
                    ) : (
                        <>
                            <ul>
                                <li>Share and <a href={links.howToMarketEvent} target="_blank" rel="noopener noreferrer">promote your event</a></li>
                                <li><a href={links.creatingDraws} target="_blank" rel="noopener noreferrer">Setup your draws</a> (after registration)</li>
                                <li>Post your scores (during event)</li>
                            </ul>
                            <p>Check out our <a href={links.eventOrganizerFaq} target="_blank" rel="noopener noreferrer">event FAQs</a> for more helpful tips.</p>
                        </>
                    )}
                {isGroupPlayEvent &&
                (
                    <Form>
                        {(formApi) => {
                            const { submitForm } = formApi;
                            return (
                                <form onSubmit={submitForm}>
                                    <div className={`form-block-content`}>
                                        <NestedField field="invitemember" validateOnSubmit={false}>
                                            {fieldApi => {
                                                return (
                                                    <div className="row">
                                                        <div className="col-9">
                                                            <p className={`text-dark text-bold mt16`}>Invite group members?</p>
                                                        </div>
                                                        <div className="col-3">
                                                            <ToggleSwitch
                                                                id={'isInviteMembers'}
                                                                field="isInviteMembers"
                                                                reverse={true}
                                                                onChange={(value) => props.onSendInviteToGroupValueChange(value, formApi, fieldApi)}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }}
                                        </NestedField>
                                    </div>
                                </form>
                            );
                        }}
                    </Form>
                )}
                <div className="mt24 mb24">
                    <div className="row">
                        <div className="col-12">
                            {isGroupPlayEvent
                                ? <button type="button" className="btn btn-primary text-uppercase btn-block" onClick={props.onSendInviteToGroup}>{props.inviteAllGroupMembers ? 'Invite Members' : 'Go to Event Page'}</button>
                                : <button type="button" className="btn btn-primary text-uppercase btn-block" onClick={props.onShareClick}>Share Your event</button>}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

PublishedPopup.propTypes = {
    firstName: PropTypes.string,
    clubName: PropTypes.string,
    eventName: PropTypes.string,
    eventDescription: PropTypes.string,
    eventStartMonth: PropTypes.string,
    eventStartDate: PropTypes.string,
    verifiedEvent: PropTypes.bool,
    onCloseClick: PropTypes.func,
    onShareClick: PropTypes.func,
    inviteAllGroupMembers: PropTypes.bool,
    onSendInviteToGroupValueChange: PropTypes.func,
    onSendInviteToGroup: PropTypes.func,
    usapVerificationTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isGroupPlayEvent: PropTypes.bool,
};

PublishedPopup.defaultProps = {
    firstName: '',
    clubName: '',
    eventName: '',
    eventDescription: '',
    eventStartMonth: '',
    eventStartDate: '',
    onCloseClick: () => {},
    onShareClick: () => {},
    onSendInviteToGroup: () => {},
    onSendInviteToGroupValueChange: () => {},
    inviteAllGroupMembers: false,
    usapVerificationTypeId: null,
    verifiedEvent: false,
    isGroupPlayEvent: false,
};

export default PublishedPopup;
